const silmasRoute ={
   about:'/about', 
   home:'/home',
   contact:'/contact',
   activity:'/activite',
   galeries:'/galerie',
   silmas_domain:'/domaines',

}
export default silmasRoute ;